import React from 'react';
import RenderSelectProduct
  from 'src/components/containers/merchandising-v2/rule/strategy/attributes/render-select-product';
import { Field } from 'redux-form';
import { withI18n } from '@shopify/react-i18n';


const ProductsTable = ({ fields, i18n }) => {
  return (
    <>
      {fields.map((member) => (
        <div style={{ padding: '20px 20px 0px 20px' }}>
          <Field
            label={i18n.translate('AdminHTML.MerchandisingV2.AttributesModal.field_Value_Label')}
            name={member}
            component={RenderSelectProduct}
          />
        </div>
      ))}
    </>
  )
}

export default withI18n()(ProductsTable);